import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentoAllegato } from "../../../models/documento-allegato";
import { FileFolders } from "../../fascicolo/documentazione-allegata-view/documentazione-allegata.component";

@Component({
  selector: 'app-option-dir-component',
  templateUrl: './option-dir-component.component.html',
  styleUrls: ['./option-dir-component.component.css']
})
export class OptionDirComponentComponent implements OnInit {
  @Input() item: FileFolders;
  @Output() onOpenUpdateMetadatiModal = new EventEmitter();
  @Output() onOpenDeleteDirModal = new EventEmitter();
  @Input() isTable = false;
  constructor() { }

  ngOnInit() {
  }

  openUpdateMetadatiModal(documento: DocumentoAllegato) {
    this.onOpenUpdateMetadatiModal.emit(documento);
  }

  openDeleteDirModal(documento: DocumentoAllegato) {
    this.onOpenDeleteDirModal.emit(documento);
  }

}
